/**
 * Composant Label
 * Label pour les formulaires
 */

import { forwardRef, type LabelHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

export interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
    required?: boolean;
}

const Label = forwardRef<HTMLLabelElement, LabelProps>(
    ({ className, children, required, ...props }, ref) => (
        <label
            ref={ref}
            className={cn(
                'text-sm font-medium leading-none text-[#1E293B] peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
                className
            )}
            {...props}
        >
            {children}
            {required && <span className="text-[#EF4444] ml-1">*</span>}
        </label>
    )
);

Label.displayName = 'Label';

export { Label };
